import React from 'react';

const DemoContent = ({ onLoadDemo }) => {
  const demoText = `# Introducing EdgeGuard™: The Next-Gen AI-Powered Firewall for the Modern Enterprise

As cyber threats continue to evolve in sophistication, traditional perimeter firewalls are no longer enough to defend today's complex enterprise networks. That's why we're proud to introduce **EdgeGuard™**, our next-generation AI-powered firewall solution, purpose-built for hybrid cloud environments and remote-first workforces.

EdgeGuard combines real-time threat detection, zero-trust segmentation, and intelligent policy automation to provide end-to-end protection from the data center to the edge.

## Why EdgeGuard™ Is Different

Unlike legacy firewalls that rely on static rule sets and port-based controls, EdgeGuard uses a behavior-based detection engine powered by continuous machine learning models. This enables EdgeGuard to detect previously unseen threats, lateral movement, and subtle anomalies — without requiring human intervention.

EdgeGuard automatically adapts its enforcement policies based on observed network behavior and device posture, meaning less manual tuning and fewer false positives for security teams.

## Key Features

- **Autonomous Threat Mitigation:** EdgeGuard detects and neutralizes zero-day threats, ransomware, and suspicious east-west traffic using an on-device AI agent trained on billions of global attack signals.
- **Zero Trust Microsegmentation:** All network access is verified continuously, with identity-aware segmentation enforced at the user, device, and app level.
- **Multi-Cloud Native:** Fully integrated with AWS, Azure, and GCP via policy-as-code templates and Terraform modules.
- **Unified Dashboard:** One console for network visualization, policy authoring, threat logs, and device inventory across all sites and clouds.
- **Edge Compute Ready:** Deployable on lightweight edge devices, Kubernetes clusters, and cloud instances with minimal overhead.

## Deployment and Use Cases

EdgeGuard is ideal for:
- Enterprises with distributed teams and branch offices
- Organizations migrating to multi-cloud
- Critical infrastructure providers needing edge enforcement
- SaaS platforms securing tenant data across hybrid networks

Deployment is seamless via container images, virtual appliances, or on bare metal. Initial configuration can be bootstrapped from our policy wizard or imported via YAML.

## Integration with Existing Tools

EdgeGuard supports native integrations with:
- SIEMs: Splunk, Datadog, Sentinel
- IAM providers: Okta, Azure AD, PingIdentity
- SD-WAN and VPNs
- XDR and EDR tools

Via our REST API and webhooks, EdgeGuard can also trigger third-party workflows or respond to incidents detected elsewhere in your security stack.

## What Sellers Should Know

EdgeGuard is not just a firewall — it's a platform. It speaks directly to CIOs, CISOs, and DevSecOps leaders looking to reduce operational burden while improving threat visibility. It's priced competitively in tiers based on data throughput and policy complexity.

Early adopters have seen up to a **73% reduction in incident response time** and a **40% improvement in east-west visibility** across environments.

Internal teams should position EdgeGuard as:
- The AI-native firewall for the hybrid enterprise
- A control plane for enforcing modern Zero Trust at scale
- A unifying platform that integrates with the customer's existing ecosystem, not one that replaces it

## Next Steps

Training materials, architecture diagrams, competitive positioning guides, and pricing calculators are available in the EdgeGuard internal launch kit. Reach out to the Enablement team or join the upcoming Sales Kickoff webinar for a live walkthrough.

Let's empower our customers to see, segment, and stop threats — with EdgeGuard.`;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-blue-900">Demo Content Available</h3>
        <button
          onClick={() => onLoadDemo(demoText)}
          className="text-xs bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition-colors"
        >
          Load Demo
        </button>
      </div>
      <p className="text-xs text-blue-700">
        Click "Load Demo" to populate the text area with sample content for testing the presentation generator.
      </p>
    </div>
  );
};

export default DemoContent; 